var ProductJs = function( item, product ) { 
    var optionsMap = {};
    var optionsMapAll = {};
    var productJs = this;
    productJs.config = {
      gallery:{
        galleryGroupByOptions: ''.split(',').map(function(s) { return s.trim() }).filter(function(v){return v!==''}),
        galleryGroupMatchMode: '4', //1 Match Everything, 2 Match Any, 4 Exclusive OR
        slickOptions: {
          autoplay: true,
          speed: 1000,
          slide: '.slide',
          slidesToShow: 3,
          slidesToScroll: 1,
          
            prevArrow: '<i class="lnr lnr-chevron-left left-arrow animation"></i>',
            nextArrow: '<i class="lnr lnr-chevron-right right-arrow animation"></i>',
          
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false,
                prevArrow: '<i class="lnr lnr-chevron-left left-arrow animation"></i>',
                nextArrow: '<i class="lnr lnr-chevron-right right-arrow animation"></i>'
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false,
                prevArrow: '<i class="lnr lnr-chevron-left left-arrow animation"></i>',
                nextArrow: '<i class="lnr lnr-chevron-right right-arrow animation"></i>'
              }
            }
          ]
        }
      }
    };

    var init = function() {
      if(!item.hasClass('initialized')) {
        initVariantStatus();
        initializeVariantSelector();
        initGallery();
        item.addClass('initialized');
      }
    };

var initVariantStatus = function() {
    $.each(product.variants, function(key, variant) {
        // Add available inventory to the variant object if inventory management is enabled
        if (variant.inventory_management) {
            variant.available_inventory = variant.inventory_quantity;
        }
        // Set the status (available or soldout)
        if (variant.available) {
            variant.status = 'available';
        } else {
            variant.status = 'soldout';
        }
    });
};

    productJs.slickFilterThumbs = function(galleryOptions, objectOptions, optionsContainer, gallerySelector, selectorContext) {
      //Example reference:
      //galleryOptions: ...
      //objectOptions: product.options
      //optionsContainer: variant;
      //gallerySelector: '#thumbs'
      //selectorContext: '#thumbs-wrapper'

      var groupOptionProperties = [];
      $(galleryOptions.galleryGroupByOptions).each(function (ix, e){
        $(objectOptions).each(function(ix2,e2){
          if (Simplistic.handleize(e) == Simplistic.handleize(e2))
            groupOptionProperties.push('option'+(1+ix2))
        })
      })
      
      if (groupOptionProperties.length>0) {
        var isSlicked = $(gallerySelector + ' .slick-track').length>0;
        if (isSlicked) {
          $(gallerySelector).slick('unslick');
        }

        selectorContext.find(gallerySelector + ' > div').hide().removeClass('slide');
        var slideSelector = '';
        $(groupOptionProperties).each(function(ix,e){
          var part1Selector = '';
          var part2Selector = '';
          if (slideSelector=='' || galleryOptions.galleryGroupMatchMode>=2)
            part1Selector += gallerySelector + ' > div';

          part1Selector += '[data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix])+'="'+Simplistic.handleize(optionsContainer[e])+'"]';
          if (galleryOptions.galleryGroupMatchMode==4) {
            part2Selector = ', ' +part1Selector;
            $(groupOptionProperties).each(function(ix2,e2){
              if (e2!=e) {
                part1Selector += ':not([data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix2])+'])';
                part2Selector += '[data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix2])+'="'+Simplistic.handleize(optionsContainer[e2])+'"]';
              }
            });
          }
          slideSelector += (slideSelector=='' || galleryOptions.galleryGroupMatchMode==1 ? '' : ', ') + part1Selector + part2Selector;
        });

        //Show the images that doesn't have any of the galleryGroupByOptions
        var withoutAltSelector = gallerySelector + ' > div';
        $(galleryOptions.galleryGroupByOptions).each(function(){
          withoutAltSelector += ':not([data-'+Simplistic.handleize(this)+'])';
        });
        slideSelector += ', ' + withoutAltSelector;

        selectorContext.find(slideSelector).show().addClass('slide');

        if (isSlicked) {
          $(gallerySelector).slick(galleryOptions.slickOptions);
        }
      }
    }

    var initializeVariantSelector = function() {
      var variantSelectorId = "product-select-"+product.id;
      var selectCallback = onVariantSelected();

      new Shopify.OptionSelectors(variantSelectorId, { product: product, onVariantSelected: selectCallback });

      if(product.options.length > 1) {
        if(product.variants.length > 1) {
          linkOptionSelectors(product);
        }

        // Add label if only one product option and it isn't 'Title'.
        if(product.options.length == 1 && product.options[0] != 'Title') {
          item.find('.selector-wrapper:eq(0)').prepend('<label>'+product.options[0]+'</label>');
        }

        item.find('.selector-wrapper label').append(':');
      } else {
        if(product.variants.length > 1) {
          item.find('.select-variant').change(function(){
            var variantSelected = false;
            $.each(product.variants, function(key, variant){
              if(variant.id==item.find('.select-variant').val()) {
                variantSelected = variant;
                return;
              }
            });
            selectCallback(variantSelected, null);
          });
        }
      }

      
        item.find('.swatch :radio').change(function() {          
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          $("[data-option-index='" + optionIndex + "']").find('.subhead').html(optionValue);
          $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });
      

      if(product.variants.length==1) {
        selectCallback(product.variants[0], null);
      } else {
        
        	productJs.setVariant(productJs.getFirstAvailableVariant());
        
      }
    };

    productJs.getFirstAvailableVariant = function() {
      for(var i=0; i < product.variants.length; i++){ 
        if(product.variants[i].available)
          return product.variants[i];
      }    
    };
  
    productJs.getVariantBySku = function(sku) {
      for(var i=0; i < product.variants.length; i++){ 
        if(product.variants[i].sku == sku)
          return product.variants[i];
      }    
    };

    productJs.getVariantById = function(id) {
      for(var i=0; i < product.variants.length; i++){ 
        if(product.variants[i].id == id) {
          return product.variants[i];
        }
      }
    };

	productJs.getCurrentVariant = function() {
    	var variantId = item.find('[name=id]').val();
      	if(variantId!="") {
        	return productJs.getVariantById(variantId);
        } else {
        	return false;
        }
    };

    productJs.setVariant = function(variant){      
      if(variant) {
        if(!isNaN(variant)) {
          variant = productJs.getVariantById(variant);
        }
        item.find('.single-option-selector').each(function(){
          var selector = this;
          var option = $(selector).data('option');
         
          $(selector).find('option').each(function(){
            if(this.value == variant[option]){
              $(selector).val(this.value).trigger('change');
              return;
            }
          });
        });
      }
    };
  
    var onVariantSelected = function() {
      return function(variant, selector) {
        if(variant && variant.id) {

          
            //Swatches code
            var form = item.find('form');
            for(var i=0,length=variant.options.length; i<length; i++) {
              var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
              if(radioButton.size()) {     
                
                var optionValue = radioButton.get(0).value;
                $(".swatch[data-option-index='" + i + "']").find('.subhead').html('\xa0'+optionValue);
                radioButton.get(0).checked = true;
              }
            }
          

          //Update the price
          item.find('.price .deal span').html(Shopify.formatMoney(variant.price, Simplistic.formatMoney).replace('.00', ''));
          if(variant.compare_at_price != null){
            item.find('.price .retail span').html(Shopify.formatMoney(variant.compare_at_price, Simplistic.formatMoney).replace('.00', ''));
            var percent = Math.round( (((variant.compare_at_price - variant.price) * 100 ) / variant.compare_at_price) );
            item.find('.off-percent strong').html(percent+'%');
          }

          //Update price for trade program customers
          if($('.price .deal.trade_program_price span')){
            var price_percentage_to_pay = $('.price .deal.trade_program_price').data('discounted-price-percentage');
            var trade_partners_discounted_price = (price_percentage_to_pay && price_percentage_to_pay > 0) ? (variant.price * price_percentage_to_pay) : variant.price;
            item.find('.price .deal.trade_program_price span').html(Shopify.formatMoney(trade_partners_discounted_price, Simplistic.formatMoney).replace('.00', ''));
            item.find('.price .retail.trade_program_price span').html(Shopify.formatMoney(variant.price, Simplistic.formatMoney).replace('.00', ''));
          }

          //Filter The images by variant
          filterImages(variant);

          //Update the variant value to add to cart
          item.find('#product-'+product.id+'-variant').val(variant.id);

          item.find('.soldout-product-message').show();
          item.find('.sold-out-button .without-extended-offer').show();
        } else {
          item.find('#product-'+product.id+'-variant').val("");
        }
        updateButtons(variant);

        $(item).trigger("variantChange", [variant]);          
      }
    };

	var filterImages = function(variant) {
      if(variant && variant.featured_image) {
        //Image in grid
        item.find('.image img').attr('src', variant.featured_image.src);

        //Main image in product page
        item.find('#active-wrapper img').attr('src', variant.featured_image.src);
        item.find('#active-wrapper a').attr('href', variant.featured_image.src);

        //Thumbs in product page
        productJs.slickFilterThumbs(productJs.config.gallery, product.options, variant, '#thumbs', item.find('#thumbs-wrapper'));
      }
    };

    var updateButtons = function(variant) {
      var status;
      if(product.available) {
        status = variant ? variant.status : 'available';
      } else {
        status = 'soldout';
      }

      item.find('.buttons-wrapper .add-button, .buttons-wrapper .sold-out-button, .soldout-product-message').hide(); //Grid
      item.find('.content-available, .content-soldout').hide(); //Product page
      switch(status) {
        case "available":
          item.find('.buttons-wrapper .add-button').show(); //Grid
          item.find('.content-available').show(); //Product page
          break;
        case "soldout":
          item.find('.buttons-wrapper .sold-out-button').show(); //Grid
          item.find('.soldout-product-message').show(); //Grid
          item.find('.content-soldout').show(); //Product page
          break;
      }
    };

    var initGallery = function(){
      
      var switchImage = function(newImageSrc, mainImageDomEl) {
  // Update the src attribute of the main image
  $(mainImageDomEl).attr('src', newImageSrc);

  // Update the srcset attribute for responsive image loading
  $(mainImageDomEl).attr('srcset',
    newImageSrc.replace('_200x', '_200x') + ' 200w,' +
    newImageSrc.replace('_300x', '_300x') + ' 300w,' +
    newImageSrc.replace('_600x', '_600x') + ' 600w,' +
    newImageSrc.replace('_1024x', '_1024x') + ' 1024w'
  );

          // Get the largest available image for zoom (e.g., 1024px wide)
  var largestImageSrc = newImageSrc;

  // Reinitialize zoom if the product gallery has the zoom-in class
  if (item.find('#product-gallery').hasClass('zoom-in')) { 
    $(mainImageDomEl).parent().trigger('zoom.destroy').zoom({
      url: largestImageSrc // Use the largest image for zoom
    });
  }

  // Update the parent anchor tag's href attribute to enable lightbox or larger image view
  $(mainImageDomEl).parents('a').attr('href', newImageSrc);
};

      //Initialize thumbs on main product page
      item.find('#thumbs.switch a.gallery').on('click', function(e) {
        e.preventDefault();
        switchImage($(this).attr('href'), item.find('#active-wrapper img')[0]);

        var variantId = $(this).attr('variant-id');
        if(variantId && variantId!='') {
          if(product.options.length <= 1) {
          	productJs.setVariant(variantId);
          }
        }
      });
      Simplistic.onImagesLoaded(item.find('#thumbs img'), function(){

             var mainProductImage = item.find('#active-wrapper img');
      mainProductImage.trigger('zoom.destroy');

       if (mainProductImage.length) {
    var largestImageSrc = mainProductImage.attr('src').replace('width=200', 'width=1024'); //Largest Image possible
    mainProductImage.parent().zoom({ url: largestImageSrc }); // Reinitialize zoom with the largest image
  }

  // Initialize the slick gallery
  item.find('#thumbs').slick(productJs.config.gallery.slickOptions);

  // Filter images based on the current variant
  filterImages(productJs.getCurrentVariant());
      });

      //Initialize zoom on main product image
     /* if(item.find('#product-gallery').hasClass('zoom-in')) {
        var mainProductImage = $('#active-wrapper img');
        if(mainProductImage.size()) {
          var zoomedSrc = item.find('#active-wrapper img').attr('src').replace('_large', '');
          item.find('#active-wrapper img')
          .wrap('<span style="display:block"></span>')
          .css('display', 'block')
          .parent()
          .zoom( { url: zoomedSrc } );
        }
      }*/

      //Initialize photoswipe on main product image
      if($('#thumbs a[rel="photoswipe"]').length > 0) {
        item.find('#thumbs a[rel="photoswipe"]').photoSwipe();
        item.find('#active-wrapper a.productImage').click(function(){
          productImage = $(this);
          item.find('#thumbs a[rel="photoswipe"]').each(function(){
            if($(this).attr('href').substr($(this).attr('href').indexOf('//')).replace(/_1024x1024/g, '') == 
            productImage.attr('href').substr(productImage.attr('href').indexOf('//')).replace(/_1024x1024/g, '')){
              $(this).click();
              return false;
            }
          });
          return false;
        });
      } else {
        if($('#active-wrapper a.productImage').length > 0) {
          item.find('#active-wrapper a.productImage').photoSwipe();
        }
      }
    }

    // (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
    // See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    var updateOptionsInSelector=function(selectorIndex){switch(selectorIndex){case 0:var key='root';var selector=item.find('.single-option-selector:eq(0)');break;case 1:var key=item.find('.single-option-selector:eq(0)').val();var selector=item.find('.single-option-selector:eq(1)');break;case 2:var key=item.find('.single-option-selector:eq(0)').val();key+=' / '+item.find('.single-option-selector:eq(1)').val();var selector=item.find('.single-option-selector:eq(2)')}
    var initialValue=selector.val();selector.empty();var options=optionsMapAll[key];if(options){for(var i=0;i<options.length;i++){var option=options[i];var newOption=jQuery('<option></option>').val(option).html(option);selector.append(newOption)}}
    var availableOptions=optionsMap[key];var existingOptions=optionsMapAll[key];item.find('.swatch[data-option-index="'+selectorIndex+'"] .swatch-element').each(function(){if(jQuery.inArray($(this).attr('data-value'),existingOptions)!==-1){if(jQuery.inArray($(this).attr('data-value'),availableOptions)!==-1){$(this).removeClass('soldout').find(':radio').removeAttr('checked')}else{$(this).addClass('soldout').find(':radio').removeAttr('checked')}
    $(this).show()}else{$(this).hide()}});if(jQuery.inArray(initialValue,availableOptions)!==-1){selector.val(initialValue)}
    selector.trigger('change')};var linkOptionSelectors=function(product){for(var i=0;i<product.variants.length;i++){var variant=product.variants[i];optionsMapAll.root=optionsMapAll.root||[];optionsMapAll.root.push(variant.option1);optionsMapAll.root=Shopify.uniq(optionsMapAll.root);if(product.options.length>1){var key=variant.option1;optionsMapAll[key]=optionsMapAll[key]||[];optionsMapAll[key].push(variant.option2);optionsMapAll[key]=Shopify.uniq(optionsMapAll[key])}
    if(product.options.length===3){var key=variant.option1+' / '+variant.option2;optionsMapAll[key]=optionsMapAll[key]||[];optionsMapAll[key].push(variant.option3);optionsMapAll[key]=Shopify.uniq(optionsMapAll[key])}
    if(variant.available){optionsMap.root=optionsMap.root||[];optionsMap.root.push(variant.option1);optionsMap.root=Shopify.uniq(optionsMap.root);if(product.options.length>1){var key=variant.option1;optionsMap[key]=optionsMap[key]||[];optionsMap[key].push(variant.option2);optionsMap[key]=Shopify.uniq(optionsMap[key])}
    if(product.options.length===3){var key=variant.option1+' / '+variant.option2;optionsMap[key]=optionsMap[key]||[];optionsMap[key].push(variant.option3);optionsMap[key]=Shopify.uniq(optionsMap[key])}}}
    updateOptionsInSelector(0);if(product.options.length>1)updateOptionsInSelector(1);if(product.options.length===3)updateOptionsInSelector(2);item.find(".single-option-selector:eq(0)").change(function(){updateOptionsInSelector(1);if(product.options.length===3)updateOptionsInSelector(2);return!0});item.find(".single-option-selector:eq(1)").change(function(){if(product.options.length===3)updateOptionsInSelector(2);return!0})}

    return init();
};

//Shopify option_selection.js
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return void 0!==t},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){return(Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e)+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return e[o]==undefined?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){o["option"+(r+1)]!=t[r]&&(i=!1)}if(1==i)return void(e=o)}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return void 0===t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i)+(n[1]?r+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_space_separator":r=i(t,2," ",",");break;case"amount_with_period_and_space_separator":r=i(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",");break;case"amount_no_decimals_with_space_separator":r=i(t,0," ");break;case"amount_with_apostrophe_separator":r=i(t,2,"'",".")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0};if(!this.selectVariantFromDropdown(t)){var e=this;setTimeout(function(){e.selectVariantFromParams(t)||e.fireOnChangeForFirstDropdown.call(e,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){this.selectVariantFromParams(t)||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames();return Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e})},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var r=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=r.length-(o?1:0));var n=r.slice(0,a),p=o?r[a]:"",l=(t.getAttribute("value"),{available:!t.disabled,id:parseFloat(t.value),price:p,option1:n[0],option2:n[1],option3:n[2]});s.push(l)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;l<a;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);return null!==e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};